export default __webpack_public_path__ + "assets/icons/us.2307142e.svg";